import { Controller } from "stimulus"

export default class extends Controller
  @targets: ["datepicker", "hourSelect", "minuteSelect"]

  clearAll: ->
    $(@datepickerTarget).datepicker("setDate", null)
    $(@hourSelectTarget).val("00")
    $(@minuteSelectTarget).val("00")